import React from "react";
import { Plus, Package, Trash2 } from "lucide-react";

export default function LeadOrdersCard({ orders, user, onAddClick, onDelete }) {
  const totalOrderValue = orders.reduce((sum, o) => sum + (o.amount || 0), 0);
  const isPrivileged = user?.role === "admin" || user?.role === "leader" || user?.role === "super_admin";

  return (
    <div className="bento-card">
      <div className="flex items-center justify-between mb-4">
        <div>
          <h2 className="text-lg font-medium text-[#1C1917]" style={{ fontFamily: "Playfair Display, serif" }}>Orders</h2>
          <p className="text-sm text-[#57534E]">Total: ₹{totalOrderValue.toLocaleString("en-IN")}</p>
        </div>
        <button onClick={onAddClick} className="btn-secondary flex items-center gap-2" data-testid="add-order-btn">
          <Plus size={16} /> Add Order
        </button>
      </div>

      {orders.length === 0 ? (
        <div className="text-center text-[#A8A29E] py-6">
          <Package size={32} className="mx-auto mb-2" />
          <p>No orders yet</p>
        </div>
      ) : (
        <div className="space-y-2">
          {orders.map((order) => (
            <div key={order.id} className="flex items-center justify-between p-3 bg-[#F5F2EA] rounded-md" data-testid={`order-${order.id}`}>
              <div>
                <p className="font-medium text-[#1C1917]">#{order.order_number}</p>
                <p className="text-sm text-[#57534E]">
                  {order.category} • {new Date(order.created_at).toLocaleDateString("en-IN")}
                </p>
              </div>
              <div className="flex items-center gap-3">
                <span className="font-semibold text-[#15803D]">
                  ₹{order.amount.toLocaleString("en-IN")}
                </span>
                {isPrivileged && (
                  <button onClick={() => onDelete(order.id)} className="text-[#A8A29E] hover:text-[#BE123C]" data-testid={`delete-order-${order.id}`}>
                    <Trash2 size={16} />
                  </button>
                )}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
